/**
 * 콤보 숫자. 화면 가운데 위.
 */

import Phaser from 'phaser';
import { TEXT_COLOR, UI_FONT } from './theme';

export class ComboMeter {
  private readonly text: Phaser.GameObjects.Text;

  constructor(scene: Phaser.Scene) {
    this.text = scene.add
      .text(scene.scale.width / 2, 86, '', {
        fontFamily: UI_FONT,
        fontSize: '28px',
        color: TEXT_COLOR.gold,
        stroke: '#14141c',
        strokeThickness: 6,
      })
      .setOrigin(0.5, 0)
      .setDepth(40)
      .setScrollFactor(0);
  }

  set(count: number): void {
    if (count < 2) {
      this.text.setText('');
      return;
    }
    this.text.setText(`${count} HIT`);
    this.text.setScale(1.15);
    this.text.scene.tweens.add({ targets: this.text, scale: 1, duration: 120 });
  }

  destroy(): void {
    this.text.destroy();
  }
}
